import React, { useState, useEffect } from "react";
import { IoIosCloseCircle } from "react-icons/io";
import { FaTrashAlt } from "react-icons/fa";
import Calendar from "react-calendar";
import moment from "moment";
import "react-calendar/dist/Calendar.css"; // Import default styles

// Function to get cookie by name
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
};

const LeaveRequestUser = ({ onClose, leaveCounts }) => {
  const [restrictedDates, setRestrictedDates] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);
  const [reason, setReason] = useState("");
  const [leaveDetails, setLeaveDetails] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [submissionStatus, setSubmissionStatus] = useState("");
  const [requestedDates, setRequestedDates] = useState([""]);

  useEffect(() => {
    const fetchRestrictedDates = async () => {
      try {
        const response = await fetch(
          "https://back-ayurveda.erp-quortech.com/v1/hris/leave/getRestrictedDate"
        );
        if (!response.ok) throw new Error("Network response was not ok");
        const data = await response.json();
        setRestrictedDates(data);
      } catch (error) {
        console.error("Error fetching restricted dates:", error);
      }
    };

    fetchRestrictedDates();
  }, []);

  const handleDateClick = (date) => {
    const formattedDate = moment(date).format("YYYY-MM-DD");
    const restricted = restrictedDates.find(
      (d) => d.restricted_dates === formattedDate
    );

    if (restricted) {
      setPopupMessage(
        `The selected date (${formattedDate}) is restricted due to: ${restricted.reason_for_restriction}`
      );
      setShowPopup(true);
    } else {
      if (!selectedDates.includes(formattedDate)) {
        setSelectedDates([...selectedDates, formattedDate]);
        setRequestedDates((prevRequestedDates) => [...prevRequestedDates, formattedDate]);
        setLeaveDetails([
          ...leaveDetails,
          { date: formattedDate, day_part: "", leave_category: "" },
        ]);
      }
    }
  };


  const handleLeaveDetailChange = (index, field, value) => {
    const newLeaveDetails = [...leaveDetails];
    newLeaveDetails[index][field] = value;
    setLeaveDetails(newLeaveDetails);
  };
  const handleRemoveDate = (index) => {
    const newSelectedDates = [...selectedDates];
    const newLeaveDetails = [...leaveDetails];
    const newRequestedDates = [...requestedDates];

    newSelectedDates.splice(index, 1);
    newLeaveDetails.splice(index, 1);
    newRequestedDates.splice(index, 1);

    setSelectedDates(newSelectedDates);
    setLeaveDetails(newLeaveDetails);
    setRequestedDates(newRequestedDates);
  };

  const handleSubmit = async () => {
    const empNo = getCookie("employee_no");
    if (!empNo) {
      setPopupMessage("Employee number not found.");
      setShowPopup(true);
      return;
    }

    const formData = new FormData();
    formData.append("employee_no", empNo);
    formData.append("reason", reason);

    // Send requested_date as a JSON string that will be parsed as an array by the backend
    formData.append("requested_date", JSON.stringify(selectedDates));

    try {
      const response = await fetch(`https://back-ayurveda.erp-quortech.com/v1/hris/leave/addleave`, {
        method: "POST",
        body: formData,
      });
      console.log(formData)
      if (response.ok) {
        setPopupMessage("Leave submitted successfully.");
        setShowPopup(true);
        onClose();
      } else {
        const errorData = await response.json();
        setPopupMessage(`Submission failed: ${errorData.message}`);
        setShowPopup(true);
      }
    } catch (error) {
      console.error("Error submitting leave:", error);
      setPopupMessage("An error occurred while submitting leave.");
      setShowPopup(true);
    }
  };


  const tileClassName = ({ date, view }) => {
    if (view === "month") {
      const formattedDate = moment(date).format("YYYY-MM-DD");
      return restrictedDates.some((d) => d.restricted_dates === formattedDate)
        ? "restricted-date"
        : "";
    }
    return "";
  };

  const tileContent = ({ date, view }) => {
    if (view === "month") {
      const formattedDate = moment(date).format("YYYY-MM-DD");
      const restricted = restrictedDates.find(
        (d) => d.restricted_dates === formattedDate
      );
      if (restricted) {
        return (
          <div title={`Restricted: ${restricted.reason_for_restriction}`}>
            <div className="w-full h-full border-2 border-red-500 rounded"></div>
          </div>
        );
      }
    }
    return null;
  };

  const closePopup = () => {
    setShowPopup(false);
    setPopupMessage("");
  };

  return (
    <div className="bg-white p-5 rounded-lg w-[600px] h-[800px] relative overflow-y-auto">
      <div className="flex justify-between items-center mb-5">
        <p className="text-[25px] font-semibold">Request for Leave</p>
        <IoIosCloseCircle className="w-8 h-8 cursor-pointer" onClick={onClose} />
      </div>

      <div className="mb-5">
        <Calendar
          onClickDay={handleDateClick}
          tileClassName={tileClassName}
          tileContent={tileContent}
        />
      </div>

      {selectedDates.map((date, index) => (
        <div key={index} className="border p-4 rounded-lg mb-3 relative">
          <p className="font-semibold">Date: {date}</p>
          <button
            type="button"
            className="absolute top-0 right-0 text-red-500 p-2"
            onClick={() => handleRemoveDate(index)}
          >
            <FaTrashAlt />
          </button>

          {leaveDetails[index].leave_category && (
            <div className="mt-2">
              <label className="block text-sm font-medium">Day Part</label>
              <select
                value={leaveDetails[index].day_part}
                onChange={(e) =>
                  handleLeaveDetailChange(index, "day_part", e.target.value)
                }
                className="border border-[#8764A0] rounded-lg h-10 w-full"
              >
                <option value="">Select Day Part</option>
                <option value="Full Day">Full Day</option>
                <option value="1st Half Day">1st Half Day</option>
                <option value="2nd Half Day">2nd Half Day</option>
              </select>
            </div>
          )}
        </div>
      ))}

      <div className="mt-5">
        <label className="block text-sm font-medium">Reason for Leave</label>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className="border border-[#8764A0] rounded-lg h-[100px] w-full"
        />
      </div>

      <div className="flex justify-end mt-5">
        <button
          type="button"
          onClick={handleSubmit}
          className="bg-[#8764A0] text-white p-3 rounded-lg"
        >
          Submit Leave Request
        </button>
      </div>

      {/* Popup for messages */}
      {showPopup && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-5 rounded-lg w-[400px]">
            <p className="text-lg font-semibold mb-4">{popupMessage}</p>
            <button onClick={closePopup} className="bg-[#8764A0] text-white p-2 rounded-lg">
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LeaveRequestUser;
